var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQtPoint = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M140 28.349c46.23 0 83.738 37.508 83.738 83.738 0 33.762-11.775 43.178-75.133 135.059a10.467 10.467 0 0 1-17.21 0h-.017c-63.371-91.881-75.116-101.297-75.116-135.059 0-46.23 37.507-83.738 83.738-83.738m0 48.847c-19.27 0-34.891 15.621-34.891 34.891S120.73 146.978 140 146.978s34.891-15.621 34.891-34.89c0-19.27-15.621-34.892-34.891-34.892"
})));
export default SvgQtPoint;